import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const onboardingWizardPlugin = createPlugin({
  id: 'onboarding-wizard',
  routes: {
    root: rootRouteRef,
  },
});

export const OnboardingWizardPage = onboardingWizardPlugin.provide(
  createRoutableExtension({
    name: 'OnboardingWizardPage',
    component: () =>
      import('./components/OnboardingWizard').then(m => m.OnboardingWizard),
    mountPoint: rootRouteRef,
  }),
);
